import { lazy, Suspense } from 'react';
import { RouteObject } from 'react-router-dom';
import { RiotOktaRouteEnum } from '~/router/@types';
import LoadingCircularProgress from '~/components/LoadingCircularProgress';

const RiotAuthOkta = lazy(() => import('~/components/User/RiotAuthOkta'));
const RiotAuthOktaCallback = lazy(() => import('~/components/User/RiotAuthOktaCallback'));

export const RIOT_OKTA_ROUTES: RouteObject[] = [
  {
    path: RiotOktaRouteEnum.Okta,
    element: (
      <Suspense fallback={<LoadingCircularProgress open />}>
        <RiotAuthOkta />
      </Suspense>
    ),
  },
  {
    path: RiotOktaRouteEnum.OktaCallback,
    element: (
      <Suspense fallback={<LoadingCircularProgress open />}>
        <RiotAuthOktaCallback />
      </Suspense>
    ),
  },
];
